import { useEffect, memo } from 'react';
import Utils from '@/common/utils/utils';
import '../NormalViewContractDetail.css';
import Plan from './Plan';
import Payment from './Payment';
import ContractTable from '../common/ContractTable';
import { caculatorTotal } from './UpdateContractHandler';

function UpdateContract({
    amountValue,
    setAmountValue,

    updateContractData,
    setUpdateContractData,

    onSaleProductList,
    setOnSaleProductList,
    onSaleEditionList,
    setOnSaleEditionList,

    product,
    setProduct,
    edition,
    setEdition,
    version,
    setVersion,
    paymentCycle,
    setPaymentCycle,

    payment,
    setPayment,

    basicSetting,
    setBasicSetting,
    advanceSetting,
    setAdvanceSetting,

    currentScreen,
    setIsUpdateConfirm,
    setIsLoading,
    setCheckErr,
    props,
    contractDetail,
    versionDataCurrent,
    currentPaymentCycle
}) {
    useEffect(() => {
        if(
            !Utils.isEmptyObject(payment) &&
            !Utils.isEmptyObject(product) &&
            !Utils.isEmptyObject(edition) &&
            !Utils.isEmptyObject(version) &&
            !Utils.isEmptyObject(basicSetting) &&
            !Utils.isEmptyObject(advanceSetting) &&
            !Utils.isEmptyObject(paymentCycle)
        ) {
            setUpdateContractData({payment, product, edition, paymentCycle, version, basicSetting, advanceSetting})
        }
    }, [payment, product, edition, paymentCycle, version, basicSetting, advanceSetting])

    useEffect(() => {
        if(
            Utils.isEmptyString(basicSetting.numOfGeneralUser?.quantity?.update) ||
            basicSetting.numOfGeneralUser.error ||
            advanceSetting.numOfTicket.error ||
            advanceSetting.numOfTicketKnowledge.error ||
            advanceSetting.numOfStorage.error ||
            advanceSetting.numberOfQACounters.error ||
            advanceSetting.numberOfSupportedCounters.error
        ) {
            return setCheckErr(true);
        }
        setPayment(caculatorTotal(basicSetting, advanceSetting, version, paymentCycle, product.increaseRate, contractDetail?.currentPaymentCycle, contractDetail?.contractStatus))
        return setCheckErr(false);
    }, [version, paymentCycle, product.increaseRate, basicSetting, advanceSetting])

    return (
        <div className="contact-update-wrapper" style={{ overflow: 'hidden' }}>
            <div className="normal-collapse">
                {/* Payment Amount */}
                <Payment
                    paymentData={payment}
                    product={product}
                    updateContractData={updateContractData}
                    version={version}
                    paymentCycle={paymentCycle}
                    amountValue={amountValue}
                    setAmountValue={setAmountValue}
                    contractDetail={contractDetail}
                    versionCurrent={versionDataCurrent}
                />

                {/* Plan */}
                <Plan
                    contractDetail={contractDetail}
                    productList={onSaleProductList}
                    setProductList={setOnSaleProductList}
                    editionList={onSaleEditionList}
                    setEditionList={setOnSaleEditionList}

                    product={product}
                    setProduct={setProduct}
                    edition={edition}
                    setEdition={setEdition}
                    setVersion={setVersion}
                    paymentCycle={paymentCycle}
                    setPaymentCycle={setPaymentCycle}
                    
                    setBasicSetting={setBasicSetting}
                    setAdvanceSetting={setAdvanceSetting}

                    setIsLoading={setIsLoading}
                    setIsUpdateConfirm={setIsUpdateConfirm}
                    API={props?.API}
                    currentPaymentCycle={currentPaymentCycle}
                />

                {/* Basic setting */}
                <ContractTable
                    currentScreen={currentScreen}
                    setIsUpdateConfirm={setIsUpdateConfirm}
                    settingData={basicSetting}
                    setSettingData={setBasicSetting}
                    paymentCycle={paymentCycle}
                    product={product}
                />

                {/* Options */}
                {!Utils.isEmptyObject(version) &&
                    version?.moduleSetting?.advancedOptionSettings && (
                        <ContractTable
                            currentScreen={currentScreen}
                            setIsUpdateConfirm={setIsUpdateConfirm}
                            settingData={advanceSetting}
                            setSettingData={setAdvanceSetting}
                            isAdvanceSetting={true}
                            paymentCycle={paymentCycle}
                            product={product}
                        />
                    )}
            </div>
        </div>
    );
}

export default memo(UpdateContract);
